import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function clientexpectation() {
  return (
    <section className="client_expectation p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/rodeo/challenges.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={704}
              height={579}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>Project Challenges</h2>
            <p>
              Rodeo Social addressed the challenge of simplifying centralized
              collaboration for teams. The focus was on creating an
              uncomplicated platform for seamless content contribution, review,
              and approval.
            </p>
            <p>
              Efficient content scheduling was a priority challenge for Rodeo
              Social. The app aimed to provide businesses with a user-friendly
              solution for easy creation, scheduling, and posting of social
              media content.
            </p>
            <p>
              Integrating gamification elements presented a distinctive
              challenge. Rodeo Social aimed to strike a precise balance,
              motivating team members without overshadowing the primary goal of
              effective social media management.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default clientexpectation;
